export const IMPORTANT_INFORMATION = "Important information";
export const VIEW_IMPORTANT_INFORMATION = "View important information";
